import { render, staticRenderFns } from "./ProductsCategoryModalForm.vue?vue&type=template&id=9b78d05e&"
import script from "./ProductsCategoryModalForm.vue?vue&type=script&lang=js&"
export * from "./ProductsCategoryModalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports